import {
  LanderQuizQuestion,
  LanderQuizQuestionTypeEnum,
  LyticsProfileVariablesEnum,
  YesNoAnswersTypeEnum,
} from "./lander-quiz.types";

export const LANDER_QUIZ_EXTRA_ENTRIES = 5;

export const SMS_QUESTION: LanderQuizQuestion = {
  title:
    "Would you like to receive text messages from FindKeepLove about new and upcoming giveaways?",
  type: LanderQuizQuestionTypeEnum.Sms,
  options: null,
  lyticsProfileVariable: LyticsProfileVariablesEnum.PhoneNumber,
};

export const DEMOGRAPHIC_QUESTIONS: LanderQuizQuestion[] = [
  {
    title: "What is your marital status?",
    type: LanderQuizQuestionTypeEnum.SingleOptionButtons,
    options: [
      { label: "Single" },
      { label: "Married" },
      { label: "Divorced" },
      { label: "Engaged" },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.MaritalStatus,
  },
  {
    title: "What is your occupation?",
    type: LanderQuizQuestionTypeEnum.FreeInput,
    options: null,
    lyticsProfileVariable: LyticsProfileVariablesEnum.Occupation,
  },
  {
    title: "What is your household income?",
    type: LanderQuizQuestionTypeEnum.DropDown,
    options: [
      { label: "< $20,000" },
      { label: "$20,000 - $49,999" },
      { label: "$50,000 - $99,999" },
      { label: "$100,00 - $149,999" },
      { label: "$150,000 - $199,999" },
      { label: "> $200,000" },
      { label: "Prefer not to say" },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.HouseholdIncome,
  },
  {
    title: "Do you have children?",
    type: LanderQuizQuestionTypeEnum.YesNoBranchQuestion,
    options: [
      { label: YesNoAnswersTypeEnum.YES },
      { label: YesNoAnswersTypeEnum.NO },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.HaveChildren,
  },
  {
    title: "What are their age ranges? (Select at least 1, then click Next.)",
    type: LanderQuizQuestionTypeEnum.MultiOptionList,
    options: [
      { label: "<1" },
      { label: "1-4" },
      { label: "5-10" },
      { label: "11-13" },
      { label: "14-18" },
      { label: "18+" },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.ChildrenAges,
  },
  {
    title: "Do you own or rent your primary residence?",
    type: LanderQuizQuestionTypeEnum.SingleOptionButtons,
    options: [{ label: "Rent" }, { label: "Own" }],
    lyticsProfileVariable: LyticsProfileVariablesEnum.Homeownership,
  },
  {
    title:
      "What shopping categories interest you? (Select at least 2, then click Next.)",
    type: LanderQuizQuestionTypeEnum.MultiOptionGrid,
    options: [
      { label: "Beauty" },
      { label: "Baby" },
      { label: "Skincare" },
      { label: "Fashion" },
      { label: "Travel" },
      { label: "Luxury" },
      { label: "Health" },
      { label: "Pets" },
      { label: "Reading" },
      { label: "Fitness" },
      { label: "Outdoors" },
      { label: "Sports" },
      { label: "Food" },
      { label: "Sustainability" },
      { label: "Home Decor" },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.ShoppingInterests,
  },
  {
    title: "Do you have a pet?",
    type: LanderQuizQuestionTypeEnum.YesNoBranchQuestion,
    options: [
      { label: YesNoAnswersTypeEnum.YES },
      { label: YesNoAnswersTypeEnum.NO },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.HavePets,
  },
  {
    title: "What kind of pet? Select all that apply.",
    type: LanderQuizQuestionTypeEnum.MultiOptionList,
    options: [
      { label: "Cat" },
      { label: "Dog" },
      { label: "Fish" },
      { label: "Birds" },
      { label: "Other" },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.PetsType,
  },
  {
    title:
      "Which of the following do you consider to be your primary ethnicity?",
    type: LanderQuizQuestionTypeEnum.DropDown,
    options: [
      { label: "American Indian or Alaskan Native" },
      { label: "Asian" },
      { label: "Native Hawaiian or Other Pacific Islander" },
      { label: "Black or African American" },
      { label: "White" },
      { label: "Hispanic or Latino" },
      { label: "Multiracial" },
      { label: "Prefer not to say" },
    ],
    lyticsProfileVariable: LyticsProfileVariablesEnum.Ethnicity,
  },
];

export const getLanderQuizQuestions = (): LanderQuizQuestion[] => {
  if (window.FKL.isNonProfitSweep) {
    return [SMS_QUESTION, ...DEMOGRAPHIC_QUESTIONS];
  }

  return [...DEMOGRAPHIC_QUESTIONS, SMS_QUESTION];
};
